import { render, staticRenderFns } from "./ProductType.vue?vue&type=template&id=67275edb&scoped=true"
import script from "./ProductType.vue?vue&type=script&lang=ts"
export * from "./ProductType.vue?vue&type=script&lang=ts"
import style0 from "./ProductType.vue?vue&type=style&index=0&id=67275edb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67275edb",
  null
  
)

export default component.exports